var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlay = void 0;
var natds_themes_1 = __importDefault(require("@naturacosmeticos/natds-themes"));
/**
 * @deprecated `overlay` is deprecated since v0.20 and will be removed at v1.0.
 * Please use `mediumHigh` opacity token from your theme.
 */
exports.overlay = {
    solidBlack: natds_themes_1.default.natura.light.opacity.mediumHigh
};
//# sourceMappingURL=index.js.map